import { useState } from 'react';

import { Button, ButtonProps } from '@/components/form/baseInputs/Button';
import { PlusIcon } from '@/components/icons/PlusIcon';
import { ProUpsellTooltip } from '@/components/poppers/ProUpsellTooltip';
import { useTenantDetailsContext } from '@/modules/tenant/TenantDetailsContext/TenantDetailsContext';
import { TenantProductTier } from '@/types/schema';

import { CreateSubBrandModal } from './SubBrandModal/CreateSubBrandModal';

export function AddSubBrandButton(props: Partial<ButtonProps>) {
  const [addModalOpen, setAddModalOpen] = useState(false);
  const { tier } = useTenantDetailsContext();

  const isDisabled = tier === TenantProductTier.Go;

  return (
    <>
      <CreateSubBrandModal
        isOpen={addModalOpen}
        onClose={() => setAddModalOpen(false)}
      />
      <ProUpsellTooltip show={isDisabled}>
        <Button
          onClick={() => setAddModalOpen(true)}
          variant="primary"
          size="sm"
          startIcon={PlusIcon}
          disabled={isDisabled}
          {...props}
        >
          Add new sub-brand
        </Button>
      </ProUpsellTooltip>
    </>
  );
}
